import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { ConfirmationButton } from '../../common/components/formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, onDelete, onEdit, ...rest }) => {

	const renderActions = (id) => {
		return (
			<div>
				<Link to={`/individualConsultationsSchedule/${id}`} disabled={isReadonly} className='btn btn-teal' style={{ marginBottom: '10px' }}>
					<FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}
				</Link>
				<br />
				<ConfirmationButton
					onConfirmation={() => onDelete(id)}
					confirmationTitle={t('IndividualConsultationSchedule_DeleteConfirmationTitle')}
					confirmationMessage={t('IndividualConsultationSchedule_DeleteConfirmationMessage')}
					displayType={'inline'}
					label={t('Common_Delete')}
					disabled={isReadonly}
				/>
			</div>
		);
	}

	const columns = [
		{
			header: t('IndividualConsultationSchedule_Center'),
			accessor: 'center.name',
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate)),
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => (ui.formatDate(endDate)),
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_StartTime'),
			accessor: 'startTime',
			cell: (startTime) => (ui.formatTime(startTime)),
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_EndTime'),
			accessor: 'endTime',
			cell: (endTime) => (ui.formatTime(endTime)),
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_RecurrenceType'),
			accessor: 'recurrenceTypeName',
			cell: (recurrenceTypeName) => t(`RecurrenceType_${recurrenceTypeName}`),
			sortable: true
		},
		{
			header: t('IndividualConsultationSchedule_DaysOfWeek'),
			accessor: 'daysOfWeek',
			cell: (daysOfWeek) => daysOfWeek ? daysOfWeek.map(d => t(`DaysOfWeek_${d.name}`)).join(", ") : ''
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => renderActions(id)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/individualConsultationsSchedule/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default List;